Vue.component("reviews-count", {
    props: [
        "total",
        "positive",
        "negative",
        "neutral",
        "reviews_by_source",
        "active_source"
    ],

    data() {
        return {
            chart: null
        };
    },

    template: `
		<div class="reviews-count">
			<div class="number-center">
				<span class="number-l" v-if="active_source">{{ reviewsByActiveSource }}</span>
				<span class="number-l" v-else>{{ total }}</span>
				<p class="light-text text-center my-0">{{ __('Reviews') }}</p>
			</div>
			<canvas ref="reviews_count_chart" width="120" height="120" class="mx-auto"></canvas>
		</div>
	`,

    mounted() {
        this.prepareChart();

        let instance = this;

        this.$eventHub.$on("updateCharts", val => {
            Vue.nextTick(function() {
                instance.updateChartData();
            });
        });
    },

    computed: {
        reviewsByActiveSource() {
            if (this.reviews_by_source.hasOwnProperty(this.active_source)) {
                return this.reviews_by_source[this.active_source].count;
            }

            return 0;
        }
    },

    methods: {
        prepareChart() {
            let area = this.$refs.reviews_count_chart;

            this.chart = new Chart(area, {
                type: "doughnut",
                data: {
                    labels: [],
                    datasets: [
                        {
                            label: "Total Reviews",
                            data: [],
                            backgroundColor: ["#29a907", "#cd3537", "#ffcb29"]
                        }
                    ]
                },
                options: {
                    legend: {
                        display: false
                    },
                    responsive: false,
                    cutoutPercentage: 90
                }
            });

            this.chart.data.labels = ["positive", "negative", "neutral"];

            this.updateChartData();
        },
        updateChartData() {
            this.chart.data.datasets[0].data = [
                this.positive,
                this.negative,
                this.neutral
            ];
            this.chart.update();
        }
    }
});
